var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getPermission.ccic.view)?_c('div',[_c('md-tabs',{staticClass:"ccic-tab",attrs:{"md-sync-route":""}},[_c('md-tab',{attrs:{"id":"tab-ccic-application","md-label":"IBD","to":"/ccic/applications"}}),_c('md-tab',{attrs:{"id":"tab-ccic-container","md-label":"Container","to":"/ccic/containers"}})],1),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }